import './update-many-modal.less';

import React from 'react';
import {Button, Checkbox, Modal, Select, Input} from 'antd';
import {inject, observer} from 'mobx-react/index';


const Option = Select.Option;
const TextArea = Input.TextArea;

@inject("clientsStore")
@observer
export class UpdateManyModel extends React.Component {

  state = {
    fieldName: null,
    value: '',
    updateOnlyEmpty: false,
    loading: false,
  };


  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.visible && !this.props.visible) {
      this.setState({ value: '', updateOnlyEmpty: false, fieldName: null, loading: false });
    }
  }

  render() {
    const { columns, visible, selected } = this.props;
    return (
      <Modal
        visible={visible}
        onCancel={::this.onCancel}
        title="Массовое обновление"
        footer={false}
        width={650}>
        <div className="clients-update-many">
          <div className="form-group">
            <label>Поле</label>
            <Select value={this.state.fieldName || this.defaultFieldName} onChange={::this.onChangeField} style={{ width: 200 }} placeholder="Выберите поле">
              {columns.map(col => (
                <Option value={col.key}>{col.name}</Option>
              ))}
            </Select>
          </div>
          <div className="form-group">
            <label>Новое значение</label>
            <TextArea
              placeholder="Новое значение"
              autoSize={{ minRows: 2, maxRows: 6 }}
              value={this.state.value}
              onChange={::this.onChangeValue}
            />
          </div>

          <div className="form-submit">
            <Button size={'large'} type="primary" onClick={::this.submit} loading={this.state.loading}>Обновить выбранные машины ({selected.length})</Button>
          </div>
        </div>
      </Modal>
    );
  }

  onChangeField(fieldName) {
    this.setState({ fieldName });
  }

  onChangeValue(e) {
    this.setState({ value: e.target.value });
  }

  onChangeOnlyEmpty(e) {
    this.setState({ updateOnlyEmpty: e.target.checked });
  }

  submit() {
    this.setState({ loading: true });
    const values = {
      fieldName: this.state.fieldName || this.defaultFieldName,
      value: this.state.value,
      updateOnlyEmpty: this.state.updateOnlyEmpty,
    };
    this.props.onSubmit(values);
  }

  onCancel() {
    this.props.onClose && this.props.onClose();
  }

  get defaultFieldName() {
    return this.props.columns[0].key;
  }

}



// WEBPACK FOOTER //
// ./src/components/pages/clients/modals/update-many-modal.js